<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="icon-credit-card"></i> Tipo de antecipação
                <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <form @submit.prevent="validate" class="needs-validation" novalidate>
                    <div class="form-row">
                        <div class="col-sm-12">
                            <base-input type="text" label="Nome" required placeholder="Digite o tipo de antecipação" v-model="model.name" v-validate="modelValidations.name" data-vv-name="name" data-vv-as="nome" maxlength="255" :error="getError('name')" />                        
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Salvar</button>
                </form>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import helperService from '../../../services/Helper/helperService'
import domainService from '../../../services/Configuration/anticipationTypeService'
import editPage from '../../../mixins/editPage'
export default {
    props: {
        id: String
    },
    mixins: [editPage],
    data() {
        return {
            actionUri: '/configuration/anticipationtype',
            model: {
                name: '',
                id: 0
            },
            modelValidations: {
                name: {
                    required: true,
                    max: 255
                }
            }
        }
    },
    computed: {
        action() {
            return this.$route.name
        }
    },
    created(){
        this.fetchData()
    },
    methods: {
        fetchData() {
            
            if(this.action == 'edit_anticipationType') {
                const self = this
                self.showLoading()
                domainService.find(this.id).then((response) =>{
                    self.model = response.data
                    self.hideLoading()
                }, () => {
                    self.hideLoading()
                })
            }
        },
        validate() {
            const self = this
            self.showLoading()
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if(this.action == 'new_anticipationType') {
                        domainService.create(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path:self.actionUri})
                        })
                    }
                    else {
                        self.model.id = self.id
                        domainService.update(self.model).then(() => {
                            self.hideLoading()
                            self.$router.push({ path: self.actionUri})
                        })
                    }
                } 
                else 
                {
                    self.hideLoading()
                }
            })
        }
    }
}
</script>
